import { getUser, getUrl,toGetBottom } from '@/api/index';

export default {
  // 为当前模块开启命名空间
  namespaced: true,

  // 模块的 state 数据
  state: () => ({
    token: localStorage.getItem('token') || '',
    iphoneInfo: {},
    userInfo: {},
    mobileCenterUrl: '', //手机端
    pcCenterUrl: '', //PC端
    aboutList: [], //尾部分类点击
    beiAn: [], //尾部备案
    bottomValue: [], //尾部客服信息
    gzhEwm: [], //尾部公众号二维码
    userInfo:{},
  }),

  // 模块的 mutations 方法
  mutations: {
    // 更新 token 字符串
    updateToken(state, token) {
      state.token = token;
      // 通过 this.commit() 方法，调用 m_user 模块下的 saveTokenToStorage 方法，将 token 字符串持久化存储到本地
      // this.commit('m_user/saveTokenToStorage')
    },
    updateIphoneInfo(state, iphoneInfo) {
      state.iphoneInfo = iphoneInfo;
    },
    UPDATA_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    UPDATA_MOBILE(state, MOBILE) {
      state.mobileCenterUrl = MOBILE;
    },
    UPDATA_PC(state, pcCenterUrl) {
      state.pcCenterUrl = pcCenterUrl;
    },
    AB_OUT: (state, aboutList) => {
      state.aboutList = aboutList;
    },
    BEI_AN: (state, beiAn) => {
      state.beiAn = beiAn;
    },
    BOTTOM_VALUE: (state, bottomValue) => {
      state.bottomValue = bottomValue;
    },
    GZH_EWM: (state, gzhEwm) => {
      state.gzhEwm = gzhEwm;
    }
  },
  actions: {
    // 获取链接信息
    GetUrl({ commit, state }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          getUrl()
            .then(res => {
              commit('UPDATA_MOBILE', res.data.data.mobileCenterUrl);
              commit('UPDATA_PC', res.data.data.pcCenterUrl);
              const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
              if (isMobile) {
                localStorage.setItem('url', res.data.data.mobileCenterUrl);
              } else {
                localStorage.setItem('url', res.data.data.pcCenterUrl);
              }
              
            })
            .catch(error => {
              reject(error);
            });
        }, 500);
      });
    },
    // 获取头部信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          getUser()
            .then(res => {
              commit('UPDATA_USERINFO', res.data.data);
            })
            .catch(error => {
              reject(error);
            });
        }, 500);
      });
    },
    //获取信息 尾部
    GetBottomInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        toGetBottom()
          .then(res => {
            console.log(res);
            commit('AB_OUT', res.data.data.aboutList);
            commit('BEI_AN', res.data.data.beiAn);
            commit('BOTTOM_VALUE', res.data.data.bottomValue);
            commit('GZH_EWM', res.data.data.gzhEwm);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
   
  },
  // 模块的 getters 属性
  getters: {}
};
